import { BLOCK_TYPES } from '../blocks/types.js';
import { SERVICE_CATALOG, servicePath } from '../../navigation/serviceCatalog.js';

// Service Content Phase 1 — Station Transfer (golden pattern: airport-transfer.js / PR #250). Authored
// FRENCH content composed exclusively from existing Content-Platform blocks and VERIFIED facts already
// live on the site:
//   - Gare SNCF de Nantes transfers      (locales: services.train "Transferts Gare" / "Gare SNCF Nantes")
//   - "connexion fluide … correspondances et déplacements professionnels"  (locales: services.train.description)
//   - Gare SNCF ↔ Aéroport Nantes route  (locales: fares.fare1Route)
//   - fixed price known upfront, 24/7, online booking, punctuality, SAB area  (shared verified facts)
// Vehicles are described BRAND-NEUTRALLY (Owner correction, PR #250 — no Mercedes/E-Class/V-Class or any
// brand/model). NO train-tracking claim: unlike airport flight-tracking, NO equivalent exists on the
// site, so it is NOT asserted (Truth-Before-Reach). NO fabricated claims (reviews/ratings/stats/awards/
// partnerships). Presentation copy only — facts/identity stay in sabProfile/jsonld. RelatedContent mesh
// derived from the ratified catalogue (WP-3.4 topology preserved).

const SLUG = 'station-transfer';
const siblings = SERVICE_CATALOG
  .filter((s) => s.slug !== SLUG)
  .map((s) => ({ label: s.name, to: servicePath(s.slug) }));

export default {
  blocks: [
    {
      type: BLOCK_TYPES.HERO,
      kicker: 'Chauffeur privé premium',
      title: 'Transfert gare SNCF de Nantes',
      lead:
        'Un chauffeur privé pour vos trajets vers et depuis la gare SNCF de Nantes — ponctuel, confortable et au tarif fixe connu à l’avance.',
    },
    {
      type: BLOCK_TYPES.INTRO,
      text:
        'Black Matte assure vos transferts gare à Nantes et en Loire-Atlantique, avec des véhicules haut de gamme et un service personnalisé, réservable en ligne et disponible 24h/24, 7j/7.',
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Pourquoi réserver votre transfert gare avec Black Matte',
      body: [
        'Un train n’attend pas. Votre chauffeur vous dépose à la gare de Nantes avec la marge nécessaire pour votre départ, et vous prend en charge à votre arrivée pour repartir sans file d’attente ni recherche de taxi.',
        'Le tarif est fixe et communiqué avant la réservation : pas de majoration de dernière minute, pas de surprise à l’arrivée. Vous voyagez à bord d’un véhicule haut de gamme, confortable et soigné, conduit par un chauffeur privé professionnel et discret.',
      ],
    },
    {
      type: BLOCK_TYPES.FEATURE_GRID,
      heading: 'Un service pensé pour la gare',
      items: [
        { title: 'Tarif fixe', text: 'Le prix est connu et confirmé avant la réservation, sans majoration de dernière minute.' },
        { title: 'Ponctualité', text: 'Une prise en charge à l’heure, pour partir à temps et repartir dès votre descente du train.' },
        { title: 'Confort', text: 'Un véhicule haut de gamme, berline ou van adapté à votre trajet et à vos bagages.' },
        { title: 'Réservation en ligne', text: 'Réservez votre transfert en quelques minutes, 24h/24 et 7j/7.' },
      ],
    },
    {
      type: BLOCK_TYPES.STEPS,
      heading: 'Comment réserver votre transfert',
      steps: [
        { title: 'Indiquez votre trajet', text: 'Renseignez votre adresse, la gare SNCF de Nantes et l’heure souhaitée.' },
        { title: 'Obtenez votre tarif fixe', text: 'Votre prix est calculé et communiqué avant de confirmer la réservation.' },
        { title: 'Confirmez en ligne', text: 'Validez votre réservation en quelques minutes, directement en ligne.' },
        { title: 'Votre chauffeur vous accueille', text: 'Votre chauffeur vous dépose à la gare ou vous prend en charge à votre arrivée.' },
      ],
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'La gare de Nantes et toute la Loire-Atlantique',
      body: [
        'Que vous arriviez à la gare SNCF de Nantes ou que vous deviez y être déposé pour un départ, Black Matte assure un trajet porte-à-porte, sans stationnement ni correspondance à gérer.',
        'Idéal pour vos correspondances et vos déplacements professionnels, notre service couvre Nantes et sa région, ainsi qu’Angers, Rennes et La Roche-sur-Yon, 24h/24 et 7j/7 — et relie aussi la gare à l’aéroport de Nantes Atlantique.',
      ],
    },
    {
      type: BLOCK_TYPES.CTA,
      heading: 'Réservez votre transfert gare',
      text: 'Obtenez votre tarif fixe et réservez votre chauffeur privé pour la gare SNCF de Nantes.',
      actions: [
        { label: 'Réserver', to: '/reserver' },
        { label: 'Tous les services', to: '/services' },
      ],
    },
    {
      type: BLOCK_TYPES.RELATED_CONTENT,
      heading: 'Autres prestations',
      links: siblings,
    },
  ],
};
